/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';
import s from './Footer.css';

function Footer() {
  return (
    <div
      className={s.root}
      style={{
        paddingTop: '50px',
        width: '100%',
      }}
    >
      <p>
        <a href="https://www.simonsfoundation.org/flatiron-institute/">
          Flatiron Institute
        </a>{' '}
        - <a href="http://simonsfoundation.org">Simons Foundation</a>
      </p>
    </div>
  );
}

export default withStyles(s)(Footer);
